import React from 'react'
import { Button } from './ui/button'

const ChangePhoneNumber: React.FC = () => {
  const handleChangePhoneNumber = () => {
    // Logic to change the phone number goes here
    console.log('Change phone number clicked')
  }
  return (
    <Button variant={'link'} className='decoration-[#5B5959]' onClick={handleChangePhoneNumber}>
      <p className='text-[#5B5959]'>
        Can't access old phone number?
      </p>
    </Button>
  )
}

export default ChangePhoneNumber